/**
 * Hotel surfaces — ILS display formatting only (round to whole shekel).
 * Does not change stored amounts, FX, or commission math.
 */

/**
 * @param {unknown} amount
 * @returns {number|null}
 */
export function roundHotelIlsForDisplay(amount) {
  const n = Number(amount);
  if (!Number.isFinite(n)) return null;
  return Math.round(n);
}

/**
 * Headline ILS line for hotel profile, payment, PDF, and order summary.
 * @param {unknown} amount raw ILS
 * @returns {string|null} e.g. "₪ 8,289"
 */
export function formatHotelIlsRoundedDisplay(amount) {
  const rounded = roundHotelIlsForDisplay(amount);
  if (rounded == null || rounded <= 0) return null;
  return `₪ ${rounded.toLocaleString("en-US")}`;
}

/**
 * Prefer authoritative `displayCurrencies.ils` over server `formattedIls` strings (may include agorot).
 * @param {{ ils?: unknown }|null|undefined} displayCurrencies
 * @returns {string|null}
 */
export function formatHotelIlsRoundedDisplayFromDisplayCurrencies(displayCurrencies) {
  if (!displayCurrencies || typeof displayCurrencies !== "object") return null;
  const ils = Number(displayCurrencies.ils);
  if (Number.isFinite(ils) && ils > 0) {
    return formatHotelIlsRoundedDisplay(ils);
  }
  return null;
}
